import { SortByTypes } from "store/current-dashboard/types";
export const horizontalStackedBarChartMapper = {
    [SortByTypes.Value]: (o) => o.custom?.categorySummedValue,
    [SortByTypes.Name]: (o) => o.custom?.category
};
